import React, { useMemo, useState } from 'react'
import { Autocomplete, Box, CircularProgress, TextField, Typography } from '@material-ui/core'
import { useOncotreeSearch } from 'src/api/oncotree'

// Compact OncoTree picker for the panel. Same server search and value shape
// ({ oncotree_code, name, ... }) as the wizard's OncotreeSelect, without its
// multi-line warning box, so it fits the 352px workflow column and a sample row.
const TumourTypeSelect = ({ id, value, onChange, placeholder = 'Search name, code or tissue', size = 'small', sx }) => {
  const [inputValue, setInputValue] = useState('')
  const query = useMemo(() => (value && inputValue === value.name ? '' : inputValue), [inputValue, value])
  const { data: options = [], isFetching } = useOncotreeSearch(query, { limit: 30 })

  return (
    <Autocomplete
      id={id}
      size={size}
      value={value || null}
      onChange={(_e, next) => onChange(next || null)}
      inputValue={inputValue}
      onInputChange={(_e, next) => setInputValue(next)}
      options={options}
      loading={isFetching}
      filterOptions={(x) => x}
      getOptionLabel={(option) => option?.name || ''}
      isOptionEqualToValue={(option, val) => option?.oncotree_code === val?.oncotree_code}
      noOptionsText={query ? 'No matching tumour type' : 'Start typing to search'}
      sx={sx}
      renderOption={(props, option) => (
        <Box component="li" {...props} key={option.oncotree_code} sx={{ gap: 1.25, alignItems: 'baseline' }}>
          <Typography component="span" sx={{ fontFamily: 'fontFamilyMono', fontSize: 13, minWidth: 56 }}>
            {option.oncotree_code}
          </Typography>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: 14 }} noWrap>
              {option.name}
            </Typography>
            {option.tissue && (
              <Typography sx={{ fontSize: 12, color: 'text.secondary' }} noWrap>
                {option.tissue}
              </Typography>
            )}
          </Box>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={value ? '' : placeholder}
          InputProps={{
            ...params.InputProps,
            sx: { fontSize: 14 },
            endAdornment: (
              <>
                {isFetching ? <CircularProgress color="inherit" size={14} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  )
}

export default TumourTypeSelect
